import { ListingResponseDtoType } from '@/api/generated/model';

export const ListingTxnType = ListingResponseDtoType;

export type ListingTxnType = (typeof ListingTxnType)[keyof typeof ListingTxnType];

export const LISTING_TXN_TYPE_OPTIONS = [
    {
        key: ListingTxnType.SALE,
        value: 'Predaj',
        slug: 'predaj',
    },
    {
        key: ListingTxnType.RENT,
        value: 'Na Prenájom',
        slug: 'na-prenajom',
    },
] as const;

export type ListingTxnTypeOption = (typeof LISTING_TXN_TYPE_OPTIONS)[number];
